import React from 'react';
import { StyledPageWrapper } from './PageWrapper.styles';

export default function PageWrapper({ children, style }) {
  return <StyledPageWrapper style={style}>{children}</StyledPageWrapper>;
}
